module.exports = ".tile-container {\n  margin: 12px 24px 24px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/businessRule/components/rule-collection-dashboard.component.scss
// module id = ./src/app/businessRule/components/rule-collection-dashboard.component.scss
// module chunks = main